import taskManagerApi from '@/features/shared/services/taskManagerApi';
/**
 * Fetch cities with optional pagination, filtering, and an "all" flag.
 * - If no page and filters are provided, it fetches the default cities.
 * - If `all` is true, it returns all cities without pagination.
 *
 * @param {number} [page] - The page number for pagination.
 * @param {Filter | CityFilters} [filters] - Filtering criteria.
 * @param {boolean} [all=false] - If true, fetch all cities.
 * @returns {Promise<CityData>} - Data containing cities and meta information.
 */
export async function fetchCities(page, filters, all = false, limit) {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(filters || {}),
            ...(all ? { all: true } : {}),
            ...(limit ? { limit } : {}),
        };
        const response = await taskManagerApi.get('/city', { params });
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération des villes");
        }
    }
}
/**
 * Delete a city by its ID.
 */
export const deleteCity = async (id) => {
    try {
        await taskManagerApi.delete(`/city/${id}`);
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la suppression de la ville");
        }
    }
};
/**
 * Create a new city.
 */
export const addCity = async (city) => {
    try {
        const response = await taskManagerApi.post('/city', city);
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de l'ajout de la ville");
        }
    }
};
/**
 * Update an existing city.
 */
export const updateCity = async (idCity, city) => {
    try {
        const response = await taskManagerApi.put(`/city/${idCity}`, city);
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la mise à jour de la ville");
        }
    }
};
/**
 * Fetch all regions.
 */
export const getAllRegions = async () => {
    try {
        const response = await taskManagerApi.get('/region', {
            params: { all: true },
        });
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération de toutes les régions");
        }
    }
};
